import { eAxis, ExtrudeFeature, isSketchNode, Token } from '@kb3d/models/classes';
import { FeatureRenderer, SubmeshVertexDataMap } from './feature';
import {
    ExtrudeGeometryDependencyData,
    ExtrudeGeometryProcessor,
    ExtrudeGeometryWorkerPayload,
} from './geometry-processor/extrude-geometry';
import { axisToVector3 } from '@kb3d/view/modules/sketching/util';
import { Vector3 } from '@babylonjs/core/Maths/math.vector';
import { SubmeshVertexData } from '@kb3d/view/helpers/geometry-helper';

export class ExtrudeRenderer<T extends ExtrudeFeature = ExtrudeFeature> extends FeatureRenderer<T> {
    modelToken = Token.ExtrudeFeature;
    processor = new ExtrudeGeometryProcessor(this.scene);

    async makeWorkerPayload(feature: T, geometryData: SubmeshVertexDataMap) {
        const payload = await super.makeWorkerPayload(feature, geometryData);

        const sketch = feature._parent && isSketchNode(feature._parent) ? feature._parent : undefined;
        const sketchNormal = sketch ? axisToVector3(sketch.normal) : Vector3.Zero();
        if (sketch && sketch.normal !== eAxis.z) {
            sketchNormal.scaleInPlace(-1);
        }

        const featureData: ExtrudeGeometryWorkerPayload = {
            sketchNormal: { x: sketchNormal.x, y: sketchNormal.y, z: sketchNormal.z },
        };

        payload.featureData = featureData;

        return payload;
    }

    updateMeshGeometry(feature: T, vertexData: SubmeshVertexData, vertexDataChanges: Partial<SubmeshVertexData>) {
        const meshDynamicId = feature._parent?._dynamicId || '';

        const sketch = feature._parent && isSketchNode(feature._parent) ? feature._parent : undefined;
        const sketchNormal = sketch ? axisToVector3(sketch.normal) : Vector3.Zero();
        if (sketch && sketch.normal !== eAxis.z) {
            sketchNormal.scaleInPlace(-1);
        }

        const dependencyData: ExtrudeGeometryDependencyData = {
            sketchNormal,
        };
        return this.processor.updateMeshGeometry(feature, vertexData, vertexDataChanges, {
            meshDynamicId,
            data: dependencyData,
        });
    }

    update3dInternal() {}
}
